<template>
    <div>
        <md-field>
            <label>{{labelText}}</label>
            <TbSelect v-model="selectedValues" md-dense multiple
					  :search-allow="true"
					  :options="industryList"
					  options-value-field="value"
					  options-display-field="name"
					  ref="select"
			/>
        </md-field>
    </div>
</template>
<script>
export default {
    props: {
        labelText: { type: String },
        columnName: { type: String },
        initialValues: { type: Array, default: [] }
    },
    data() {
        return {
            selectedValues: this.initialValues.map(Number),
            industryList: [],
        };
    },
    beforeMount() {
        this.initData();
    },
    methods: {
        clearFilter() {
            this.selectedValues = [];
			this.$refs.select.resetSearch();
        },
        getFilter() {
            if (this.selectedValues.length === 0) {
                return null;
            }

            return [{
                columnName: this.columnName,
                fieldType: "L",
                matchType: "IN",
                value: this.selectedValues.join(",")
            }];
        },
        initData() {
            this.industryList = [];
            for (let id = 1; id <= 21; id++) {
                let industryItem = {
                    value: id,
                    name: this.$t("common.industry." + id)
                };
                this.industryList.push(industryItem);
            }
        },
        setFilter(filter) {
            this.selectedValues = filter.value.split(",").map(Number);
        }
    }
};
</script>
